module.exports = __webpack_public_path__ + "assets/d7ad9a47ea0cefd9ecf63edf50ae7ea0.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/L585MLA_Sml_ReelSpin_Long.mp3
 ** module id = 241
 ** module chunks = 0
 **/